import script from "./HrSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSpinner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QSpinnerDots});
